import { render, staticRenderFns } from "./SpecialEvent.vue?vue&type=template&id=045f2d56&scoped=true&"
import script from "./SpecialEvent.vue?vue&type=script&lang=js&"
export * from "./SpecialEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045f2d56",
  null
  
)

export default component.exports